module.exports = "/static/images/menu-blog.jpg";